import { render, staticRenderFns } from "./UpdateEdit.vue?vue&type=template&id=54e85271&scoped=true&"
import script from "./UpdateEdit.vue?vue&type=script&lang=js&"
export * from "./UpdateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e85271",
  null
  
)

export default component.exports